import { useState } from 'react';
import { WarningIcon } from '../icons';
import { IconButton, IconButtonVariant, IconButtonSize, IconName } from '@hills-design-system/components';

const addArrowToLinks = (html: string): string => {
  return html.replace(/<\/a>/g, ' →</a>');
};

interface CmsNoSearchResultsSuggestionsProps {
  data: {
    name?: string;
    component?: string;
    body?: string;
    media?: unknown;
    media_position?: string;
    buttons?: unknown[];
    _metadata?: { uid: string };
  };
}

export const CmsNoSearchResultsSuggestions: React.FC<CmsNoSearchResultsSuggestionsProps> = ({
  data,
}) => {
  const [dismissed, setDismissed] = useState(false);

  if (!data?.body || dismissed) {
    return null;
  }

  return (
    <div className="w-full relative z-[2]">
      <div className="max-w-7xl mx-auto px-6 py-75 flex items-center gap-75 bg-banner-danger-bg border-b border-banner-danger-border">
        <div className="flex-shrink-0 w-1 h-12 bg-banner-danger-icon rounded-full"></div>

        <div className="flex-shrink-0">
          <WarningIcon className="text-banner-danger-icon flex-shrink-0" width={24} height={24} />
        </div>

        <div
          className="flex-1 min-w-0 [&_p]:text-detail-90 [&_p]:text-black-800 [&_p]:font-medium [&_p]:leading-detail [&_p]:m-0 [&_a]:!text-primary [&_a]:font-bold [&_a]:transition-colors [&_a]:duration-200 [&_a:hover]:!text-primary-hover [&_a]:inline-flex [&_a]:items-center [&_a]:gap-25 [&_a]:underline"
          dangerouslySetInnerHTML={{ __html: addArrowToLinks(data.body) }}
        />

        <IconButton
          icon={IconName.X}
          variant={IconButtonVariant.Tertiary}
          size={IconButtonSize.Small}
          onClick={() => setDismissed(true)}
          ariaLabel="Dismiss notification"
          className="flex-shrink-0"
        />
      </div>
    </div>
  );
};

export default CmsNoSearchResultsSuggestions;
